<template>
  <div style="text-align:left;background:white">
    <div style="text-align:center">
      <div style="padding:20px">
        <img class="index-logo" height="50px" src="static/indexnoslus.svg">
      </div>
      <div v-if="status === 0">
        Login
      </div>
      <div v-if="status === 1" class="dotaznik" :style="($isMobile()) ? 'padding:5px' : 'padding:20px'">
        <div style="color:#409EFF;text-align:center;font-weight:600;font-size:18px">
          Prosíme vyplniť doplňujúce otázky k Vašej pracovnej zmluve
        </div>
        
          <el-form ref="form" :rules="rules" :model="form" label-position="top" style="margin-top:20px">
            <!-- Otázka 1 -->
            <el-card shadow="never" style="padding:0px;margin-top:20px;background:#fbfcff">
              <div style="width:25px;height:25px;border-radius:2px;font-size:18px;background:#409EFF;color:white;text-align:center">1</div>
              <div style="padding:20px">
                <el-form-item prop="question_1" style="margin-top:10px">
                  <span slot="label">
                    <b>Pracujete / pracovali ste v tomto mesiaci aj u iného zamestnávateľa ?</b>
                  </span>
                  <div style="margin-left:10px;margin-top:5px">
                    <el-radio-group v-model="form.question_1">
                      <el-radio border label="true">Áno</el-radio>
                      <el-radio border label="false">Nie</el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <!-- Otázka 1a -->
                <el-collapse-transition>
                  <div v-show="form.question_1 === 'true'">
                  <el-form-item prop="question_1a">
                    <span slot="label">
                      <b>Bude Váš pracovný pomer u iného zamestnávateľa pokračovať aj naďalej (ďalšie mesiace) popri práci u nás ?</b>
                    </span>
                    <div style="margin-left:10px;margin-top:5px">
                      <el-radio-group v-model="form.question_1a">
                        <el-radio border label="true">Áno</el-radio>
                        <el-radio border label="false">Nie</el-radio>
                      </el-radio-group>
                    </div>
                  </el-form-item>
                  </div>
                </el-collapse-transition>
              </div>
            </el-card>

            <!-- Otázka 2 -->
            <el-card shadow="never" style="margin-top:20px;background:#fbfcff">
              <div style="width:25px;height:25px;border-radius:2px;font-size:18px;background:#409EFF;color:white;text-align:center">2</div>
              <div style="padding:20px">
                <el-form-item style="margin-top:5px" prop="question_2">
                  <span slot="label">
                    <b>Ak nikde inde nepracujete, môžete si uplatniť NEZDANITEĽNÚ ČASŤ základu dane</b>
                    <span style="font-weight:400">(nezdaniteľná časť je suma, o ktorú si môžete znížiť základ, z ktorého sa Vám vypočíta 19% Daň z príjmu, ktorú platíte zo svojej mzdy)</span>
                  </span>
                  <div style="margin-left:10px;margin-top:5px">
                    <el-radio-group v-model="form.question_2">
                      <!-- style="width:100%;padding-bottom:5px" -->
                      <el-radio border label="true">ÁNO MÁM ZÁUJEM uplatniť - nemám to nikde inde uplatnené</el-radio>
                      <el-radio border label="false">NIE nechcem uplatniť</el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </div>
            </el-card>

            <!-- Otázka 3 -->
            <el-card shadow="never" style="margin-top:20px;background:#fbfcff">
              <div style="width:25px;height:25px;border-radius:2px;font-size:18px;background:#409EFF;color:white;text-align:center">3</div>
              <div style="padding:20px">
                <el-form-item style="margin-top:5px" prop="question_3">
                  <span slot="label">
                    <b>Ak máte deti vo veku do 26 rokov a študujú, môžete si uplatniť DAŇOVÝ BONUS (pokiaľ si ho neuplatňuje partner/ka)</b>
                  </span>
                  <div style="margin-left:10px;margin-top:5px">
                    <el-radio-group v-model="form.question_3">
                      <el-radio border label="true">ÁNO MÁM ZÁUJEM uplatniť</el-radio>
                      <el-radio border label="false">NIE nechcem uplatniť</el-radio>
                    </el-radio-group>
                  </div>
                  <el-collapse-transition>
                    <div v-show="form.question_3 === 'true'" style="margin-left:10px;margin-top:20px">
                      <div>
                        <strong>Priložte odfotený rodný list dieťaťa a potvrdenie o návšteve školy ak študuje na strednej alebo vysokej škole</strong>
                        <el-upload 
                          ref="uploadQ3" 
                          :action="uploadUrl + '/3'" 
                          :on-change="fileChange3"
                          :on-success="fileSuccess3"
                          :on-progress="fileProgress3"
                          :on-error="fileError3"
                          :on-preview="filePreview"
                          :on-remove="fileRemove"
                          :before-upload="fileBeforeUpload3"
                          :show-file-list="true"
                          multiple 
                          :limit="2" 
                          drag 
                          :auto-upload="false" 
                          style="width:100%;margin-top:5px">
                          <i class="el-icon-upload"></i>
                          <div>Sem pretiahnite súbor alebo <em> kliknutím vyberte zo súboru</em></div>
                        </el-upload>
                      </div>
                    </div>
                  </el-collapse-transition>
                </el-form-item>
              </div>
            </el-card>

            <!-- Otázka 4 -->
            <el-card shadow="never" style="margin-top:20px;background:#fbfcff">
              <div style="width:25px;height:25px;border-radius:2px;font-size:18px;background:#409EFF;color:white;text-align:center">4</div>
              <div style="padding:20px">
                <el-form-item style="padding-top:5px" prop="question_4">
                  <span slot="label">
                    <b>Ste poberateľom starobného, invalidného alebo predčasného starobného dôchodku, alebo ste držiteľom ZŤP preukazu?</b>
                  </span>
                  <div style="margin-left:10px;margin-top:5px">
                    <el-radio-group v-model="form.question_4">
                      <el-radio border label="true">Áno</el-radio>
                      <el-radio border label="false">Nie</el-radio>
                    </el-radio-group>
                  </div>
                  <el-collapse-transition>
                    <div v-show="form.question_4 === 'true'" style="margin-left:10px;margin-top:20px">
                      <div>
                        <strong>Priložte prosím SCAN (alebo FOTKU) rozhodnutia zo Sociálnej poisťovne alebo výmer</strong>
                        <el-upload 
                          ref="uploadQ4"
                          :action="uploadUrl + '/4'" 
                          :on-change="fileChange4"
                          :on-success="fileSuccess4"
                          :on-progress="fileProgress4"
                          :on-error="fileError4"
                          :on-preview="filePreview"
                          :on-remove="fileRemove"
                          :before-upload="fileBeforeUpload4"
                          :show-file-list="true"
                          :limit="1" 
                          drag 
                          :auto-upload="false" 
                          style="width:100%;margin-top:5px">
                          <i class="el-icon-upload"></i>
                          <div>Sem pretiahnite súbor alebo <em> kliknutím vyberte zo súboru</em></div>
                        </el-upload>
                      </div>
                    </div>
                  </el-collapse-transition>
                </el-form-item>
              </div>
            </el-card>

            <!-- Otázka 5 -->
            <el-card shadow="never" style="margin-top:20px;background:#fbfcff">
              <div style="width:25px;height:25px;border-radius:2px;font-size:18px;background:#409EFF;color:white;text-align:center">5</div>
              <div style="padding:20px">
                <el-form-item style="padding-top:5px" prop="question_5">
                  <span slot="label">
                    <b>Vlastníte osvedčenie, ktoré sme Vám zdôrazňovali, že potrebujete pre prácu u nás?</b>
                    <span style="font-weight:400">
                      (preukaz na VZV, NZV, potravinársky preukaz, hygienické minimum,...)
                    </span>
                  </span>
                  <div style="margin-left:10px;margin-top:5px">
                    <el-radio-group v-model="form.question_5">
                      <el-radio border label="true">Áno</el-radio>
                      <el-radio border label="false">Nie</el-radio>
                    </el-radio-group>
                  </div>
                  <el-collapse-transition>
                    <div v-show="form.question_5 === 'true'" style="margin-left:10px;margin-top:20px">
                      <div>
                        <strong>Priložte prosím SCAN (alebo FOTKU)</strong>
                        <el-upload style="width:100%;margin-top:5px" 
                          ref="uploadQ5" 
                          :action="uploadUrl + '/5'" 
                          :on-change="fileChange5"
                          :on-success="fileSuccess5"
                          :on-progress="fileProgress5"
                          :on-error="fileError5"
                          :on-preview="filePreview"
                          :on-remove="fileRemove"
                          :before-upload="fileBeforeUpload5"
                          :show-file-list="true"
                          :limit="1" 
                          drag 
                          :auto-upload="false">
                          <i class="el-icon-upload"></i>
                          <div>Sem pretiahnite súbor alebo <em> kliknutím vyberte zo súboru</em></div>
                        </el-upload>
                      </div>
                    </div>
                  </el-collapse-transition>
                </el-form-item>
              </div>
            </el-card>
            
            <!-- Prilohy -->
            <div style="padding-top:30px">
              <b>Priložte prípadne inú prílohu, ktorú nám potrebujete zaslať (max 3)</b>
              <el-upload style="margin-top:10px;width:100%" 
                ref="upload" 
                :action="uploadUrl + '/0'" 
                :on-change="fileChange"
                :on-success="fileSuccess"
                :on-progress="fileProgress"
                :on-error="fileError"
                :on-preview="filePreview"
                :on-remove="fileRemove"
                :before-upload="fileBeforeUpload"
                :show-file-list="true" 
                :limit="3" 
                drag multiple
                :auto-upload="false">
                <i class="el-icon-upload"></i>
                <div>Sem pretiahnite súbor alebo <em> kliknutím vyberte zo súboru</em></div>
              </el-upload>
            </div>
          </el-form>
          <div style="margin-top:20px;text-align:right">
            <el-button @click="upload()" type="primary">Odoslať</el-button>
          </div>
        <!-- </el-card> -->
      </div>
      <div v-if="status === 2">
        Ďakujeme
      </div>
      <div v-if="status === 9">
        Dotaznik sa odosiela, prosím čakajte kým sa nahrajú všetky dokumenty...
        <div style="padding:40px">
          <div v-for="item in uploadFileList" :key="item.uid">
            <span>{{item.name}}</span>
            <el-progress status="exception"
              :percentage="item.percentage"
              :text-inside="true"
              :stroke-width="15">
            </el-progress>
          </div>
        </div>
      </div>
      <div v-if="status === 99">
        Neplatná linka...
      </div>
    </div>
  </div>
</template>

<script>
import { updateForm, validateForm } from '@/api/noslus_sk'

export default {
  data () {
    var validateQ1a = (rule, value, callback) => {
      if (this.form.question_1 == 'false') {
        callback()
      }
      else {
        if (value === undefined) {
          callback(new Error('Prosím zvolte jednu z možností'))
        }
        else {
          callback()
        }
      }
    }
    return {
      isUploading: false,
      uploadUrl: undefined,
      baseUrl: undefined,
      uploadFileList: [],
      uploads: [],
      status: 1, //  0 - login, 1 - formular, 2 - dakujeme
      form_id: undefined,
      form: {
        question_1: undefined,
        question_1a: undefined,
        question_2: undefined,
        question_3: undefined,
        question_4: undefined,
        question_5: undefined
      },
      rules: {
        question_1: [
          { required: true, message: 'Prosím zvolte jednu z možností', trigger: 'change' }
        ],
        question_1a: [
          { validator: validateQ1a, trigger: 'change'}
          //{ required: (!this.form.question_1), message: 'Prosím zvolte jednu z možností', trigger: 'change' }
        ],
        question_2: [
          { required: true, message: 'Prosím zvolte jednu z možností', trigger: 'change' }
        ],
        question_3: [
          { required: true, message: 'Prosím zvolte jednu z možností', trigger: 'change' }
        ],
        question_4: [
          { required: true, message: 'Prosím zvolte jednu z možností', trigger: 'change' }
        ],
        question_5: [
          { required: true, message: 'Prosím zvolte jednu z možností', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    uploadFileList: function (data) {
      console.log('[watch] uploadFileList:', data.length)
      if (this.isUploading) {
        if (data.length === 0) {
          this.saveForm()
        }
      }

    }
  },
  created () {
    this.form_id = this.$route.params.id
    this.baseUrl = process.env.BASE_API + '/noslus_sk/' + this.form_id + '/upload'
    this.uploadUrl = this.baseUrl
    this.checkForm()
  },
  methods: {
    checkForm() {
      validateForm(this.form_id)
        .then(resp => {
          if (resp.data.status === false) {
            this.status = 99
          }
          else {
            this.status = 1
          }
        })
        .catch(err => {
          console.log('err 99', err)
          this.status = 99
        }) 
    },
    upload () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.initiateRef('Q3')
          this.initiateRef('Q4')
          this.initiateRef('Q5')
          this.initiateRef('')

          if (this.uploadFileList.length === 0) {
            this.saveForm()
          }
        }
        else {
          console.log('not valid')
        }
      })
    },
    initiateRef (x) {
      console.log('initiateRef', 'upload' + x)
      this.uploadQuestionDocuments(x)
    },
    uploadQuestionDocuments (p_question) {
      console.log('[uploadQuestionDocuments]', p_question)
      this.status = 9
      this.isUploading = true
    
      switch (p_question) {
        case 'Q3': {
          this.$refs.uploadQ3.submit()
        }
          break
        case 'Q4': {
          this.$refs.uploadQ4.submit()
        }
          break
        case 'Q5': {
          this.$refs.uploadQ5.submit()
        }
          break
        case '': {
          this.$refs.upload.submit()
        }
          break
      }
    },
    filePreview (file) {
      console.log('handlePreview:', file)
    },
    fileRemove (file) {
      console.log('fileRemove', file)
    },
    //
    fileBeforeUpload (file) {
      console.log('[UPLOADSTART]:', file.name)
      this.uploads.push({
        question: '',
        name: file.name,
        size: file.size,
        percentage: 0,
        progress: true,
        uid: file.uid
      })
      //console.log('[UPLOADSTART] uploads:',this.uploads)
    },
    fileChange (file, fileList) {
      console.log('[CHANGE] file:', file.name, file.percentage)
      //console.log('[CHANGE] fileList:', fileList.length, fileList)

      if (file.percentage === 0) {
        const updfile = this.uploadFileList.find(x => x.uid === file.uid)
        if (!updfile) {
          this.uploadFileList.push({
            uid: file.uid,
            name: file.name,
            percentage: file.percentage
          })
        }
      }

      let upload = this.uploads.find(x => x.uid == file.uid)
      if (upload) {
        upload.percentage = file.percentage
      }
    },
    fileProgress (event, file, fileList) {
      //console.log('[PROGRESS] event:', event.percent)
      console.log('[PROGRESS] file:', file.name, event.percent)
      //console.log('[PROGRESS] fileList:',fileList.length)
      if (file) {
        let upload = this.uploads.find(x => x.uid == file.uid)
        if (upload) {
          upload.percentage = event.percent
        }
        let upl = this.uploadFileList.find(x => x.uid === file.uid)
        if (upl) {
          upl.percentage = event.percent
        }
      }
    },
    fileSuccess (response, file, fileList) {
      console.log('[SUCCESS] response:', response)
      console.log('[SUCCESS] file:', file.name)
      //console.log('[SUCCESS] fileList:',fileList)
      const uploadFile = this.uploadFileList.find(x => x.uid == file.uid)
      if (uploadFile) {
        const index = this.uploadFileList.indexOf(uploadFile)
        this.uploadFileList.splice(index, 1)
      }
      const upload = this.uploads.find(x => x.uid == file.uid)
      if (upload) {
        const index = this.uploads.indexOf(upload)
        this.uploads.splice(index, 1)
      }
    },
    fileError (err, file, fileList) {
      console.log('[ERROR] err', err)
      console.log('[ERROR] file:', file.name)
      this.$message.error('Odoslanie súboru ' + file.name + ' zlyhalo')
      const uploadFile = this.uploadFileList.find(x => x.uid == file.uid)
      if (uploadFile) {
        const index = this.uploadFileList.indexOf(uploadFile)
        this.uploadFileList.splice(index, 1)
      }
    },
    // 3
    fileBeforeUpload3 (file) {
      console.log('[UPLOADSTART 3]:', file.name)
      this.uploads.push({
        question: '3',
        name: file.name,
        size: file.size,
        percentage: 0,
        progress: true,
        uid: file.uid
      })
      //console.log('[UPLOADSTART] uploads:',this.uploads)
    },
    fileChange3 (file, fileList) {
      console.log('[CHANGE 3] file:', file.name, file.percentage)

      if (file.percentage === 0) {
        const updfile = this.uploadFileList.find(x => x.uid === file.uid)
        if (!updfile) {
          this.uploadFileList.push({
            uid: file.uid,
            name: file.name,
            percentage: file.percentage
          })
        }
      }

      let upload = this.uploads.find(x => x.uid == file.uid)
      if (upload) {
        upload.percentage = file.percentage
      }
    },
    fileProgress3 (event, file, fileList) {
      // console.log('[PROGRESS] event:', event.percent)
      console.log('[PROGRESS 3] file:', file.name, event.percent)
      // console.log('[PROGRESS] fileList:',fileList.length)
      if (file) {
        let upload = this.uploads.find(x => x.uid == file.uid)
        if (upload) {
          upload.percentage = event.percent
        }
        let upl = this.uploadFileList.find(x => x.uid === file.uid)
        if (upl) {
          upl.percentage = event.percent
        }
      }
    },
    fileSuccess3 (response, file, fileList) {
      console.log('[SUCCESS 3] response:', response)
      console.log('[SUCCESS 3] file:', file.name)
      //console.log('[SUCCESS] fileList:',fileList)

      const uploadFile = this.uploadFileList.find(x => x.uid == file.uid)
      if (uploadFile) {
        const index = this.uploadFileList.indexOf(uploadFile)
        this.uploadFileList.splice(index, 1)
      }

      const upload = this.uploads.find(x => x.uid == file.uid)
      if (upload) {
        const index = this.uploads.indexOf(upload)
        this.uploads.splice(index, 1)
      }
    },
    fileError3 (err, file, fileList) {
      console.log('[ERROR 3] err', err)
      console.log('[ERROR 3] file:', file.name)
      this.$message.error('Odoslanie súboru ' + file.name + ' zlyhalo')
      const uploadFile = this.uploadFileList.find(x => x.uid == file.uid)
      if (uploadFile) {
        const index = this.uploadFileList.indexOf(uploadFile)
        this.uploadFileList.splice(index, 1)
      }
    },
    // 4
    fileBeforeUpload4 (file) {
      console.log('[UPLOADSTART 4]:', file.name)
      this.uploads.push({
        question: '4',
        name: file.name,
        size: file.size,
        percentage: 0,
        progress: true,
        uid: file.uid
      })
      //console.log('[UPLOADSTART] uploads:',this.uploads)
    },
    fileChange4 (file, fileList) {
      console.log('[CHANGE 4] file:', file.name, file.percentage)

      if (file.percentage === 0) {
        const updfile = this.uploadFileList.find(x => x.uid === file.uid)
        if (!updfile) {
          this.uploadFileList.push({
            uid: file.uid,
            name: file.name,
            percentage: file.percentage
          })
        }
      }
      let upload = this.uploads.find(x => x.uid == file.uid)
      if (upload) {
        upload.percentage = file.percentage
      }
    },
    fileProgress4 (event, file, fileList) {
      // console.log('[PROGRESS] event:', event.percent)
      console.log('[PROGRESS 4] file:', file.name, event.percent)
      // console.log('[PROGRESS] fileList:',fileList.length)
      if (file) {
        let upload = this.uploads.find(x => x.uid == file.uid)
        if (upload) {
          upload.percentage = event.percent
        }
        let upl = this.uploadFileList.find(x => x.uid === file.uid)
        if (upl) {
          upl.percentage = event.percent
        }
      }
    },
    fileSuccess4 (response, file, fileList) {
      console.log('[SUCCESS 4] response:', response)
      console.log('[SUCCESS 4] file4:', file.name)
      //console.log('[SUCCESS] fileList:',fileList)

      const uploadFile = this.uploadFileList.find(x => x.uid == file.uid)
      if (uploadFile) {
        const index = this.uploadFileList.indexOf(uploadFile)
        this.uploadFileList.splice(index, 1)
      }
      const upload = this.uploads.find(x => x.uid == file.uid)
      if (upload) {
        const index = this.uploads.indexOf(upload)
        this.uploads.splice(index, 1)
      }
    },
    fileError4 (err, file, fileList) {
      console.log('[ERROR 4] err', err)
      console.log('[ERROR 4] file:', file.name)
      this.$message.error('Odoslanie súboru ' + file.name + ' zlyhalo')
      const uploadFile = this.uploadFileList.find(x => x.uid == file.uid)
      if (uploadFile) {
        const index = this.uploadFileList.indexOf(uploadFile)
        this.uploadFileList.splice(index, 1)
      }
    },
    // 5
    fileBeforeUpload5 (file) {
      console.log('[UPLOADSTART 5]:', file.name)
      this.uploads.push({
        question: '5',
        name: file.name,
        size: file.size,
        percentage: 0,
        progress: true,
        uid: file.uid
      })
    },
    fileChange5 (file, fileList) {
      console.log('[CHANGE 5] file:', file.name, file.percentage)

      if (file.percentage === 0) {
        const updfile = this.uploadFileList.find(x => x.uid === file.uid)
        if (!updfile) {
          this.uploadFileList.push({
            uid: file.uid,
            name: file.name,
            percentage: file.percentage
          })
        }
      }
      let upload = this.uploads.find(x => x.uid == file.uid)
      if (upload) {
        upload.percentage = file.percentage
      }
    },
    fileProgress5 (event, file, fileList) {
      // console.log('[PROGRESS] event:', event.percent)
      console.log('[PROGRESS 5] file:', file.name, event.percent)
      // console.log('[PROGRESS] fileList:',fileList.length)
      if (file) {
        let upload = this.uploads.find(x => x.uid == file.uid)
        if (upload) {
          upload.percentage = event.percent
        }
        let upl = this.uploadFileList.find(x => x.uid === file.uid)
        if (upl) {
          upl.percentage = event.percent
        }
      }
    },
    fileSuccess5 (response, file, fileList) {
      console.log('[SUCCESS 5] response:', response)
      console.log('[SUCCESS 5] file:', file.name)
      //console.log('[SUCCESS] fileList:',fileList)

      const uploadFile = this.uploadFileList.find(x => x.uid == file.uid)
      if (uploadFile) {
        const index = this.uploadFileList.indexOf(uploadFile)
        this.uploadFileList.splice(index, 1)
      }
      const upload = this.uploads.find(x => x.uid == file.uid)
      if (upload) {
        const index = this.uploads.indexOf(upload)
        this.uploads.splice(index, 1)
      }
    },
    fileError5 (err, file, fileList) {
      console.log('[ERROR 5] err', err)
      console.log('[ERROR 5] file:', file.name)
      this.$message.error('Odoslanie súboru ' + file.name + ' zlyhalo')
      const uploadFile = this.uploadFileList.find(x => x.uid == file.uid)
      if (uploadFile) {
        const index = this.uploadFileList.indexOf(uploadFile)
        this.uploadFileList.splice(index, 1)
      }
    },
    //
    saveForm () {
      let data = {
        question_1: (this.form.question_1 === 'true'),
        question_1a: (this.form.question_1a === 'true'),
        question_2: (this.form.question_2 === 'true'),
        question_3: (this.form.question_3 === 'true'),
        question_4: (this.form.question_4 === 'true'),
        question_5: (this.form.question_5 === 'true')
      }
      this.status = 9
      updateForm(this.form_id, data)
        .then(resp => {
          this.status = 2
        })
        .catch((err) => {
          console.log(err)
          this.status = 1
        })
    }
  }
}
</script>

<style>
  .body {
    background: white;
  }
  
  .dotaznik {
    margin: auto;
    text-align: left;
    max-width: 900px;
  }
  .dotaznik b{
    font-size:15px;
    color: #303133;
  }
  .dotaznik span{
    font-size:14px;
    /* color: #606266; */
  }
  .dotaznik .el-upload-dragger {
    width: 100% !important;
  }
  .dotaznik .el-upload {
    width: 100% !important;
  }

  .dotaznik .el-form-item--medium .el-form-item__content, .el-form-item--medium .el-form-item__label {
    line-height: 20px;
  }

  .dotaznik .el-radio {
    margin-right: 5px;
    color: #606266;
    background: white;
  }

  .dotaznik .el-card__body {
    padding:0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NoslusSk/dotaznik.vue